$(document).ready(() => {
    const html = $('html');
    const header = $('#header');
    const menu = header.find('.menu');
    const openSubmenu = menu.find('.arrow');

	const open = $('.mobile-menu-open');
	const close = $('.mobile-menu-close');

	let scrollPosition = null;

	open.on('click', () => {
		scrollPosition = html.scrollTop();

		html.css({
			position: 'fixed',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			overflow: 'hidden'
		});

		menu.addClass('active');
	});

	close.on('click', () => {
		html.removeAttr('style');
		html.scrollTop(scrollPosition);

		menu.find('li.item.opened')
			.removeClass('opened')
			.find('.sub-menu')
			.removeAttr('style');

		menu.removeClass('active');
	});

	openSubmenu.on('click', (e) => {
		if ($(window).width() < 960) {
			const arrow = $(e.currentTarget);
			const parent = arrow.parents('.item');
			const submenu = parent.find('.sub-menu');

			if (parent.hasClass('opened')) {
				parent.removeClass('opened');
			} else {
				parent.addClass('opened');
			}

			submenu.toggle(('normal'));
		}
    });
});
